export const sanitize = (toSanitize: string) =>
  toSanitize
    .toLowerCase()
    .replace(/[ '\-_]/g, '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

export const search = (base: string, searched: string) =>
  sanitize(base).includes(sanitize(searched))
